import styled from 'styled-components'

const Wrapper = styled('div')`
  margin-top: 8px;

  &:first-child {
    margin-top: 0;
  }
`

export default Wrapper
